import { forwardRef } from 'react';
import { Control, Controller } from 'react-hook-form';

import { ConfidentialInput } from '@/components';

export interface FormConfidentialInputProps {
  control: Control<any>;
  name: string;
  placeholder: string;
  sensitiveLabel?: string;
  disabled?: boolean;
  required?: boolean;
  autoFocus?: boolean;
  onBlur?: () => void;
  hideLabel?: boolean;
}

const FormConfidentialInput = forwardRef<
  HTMLInputElement,
  FormConfidentialInputProps
>(
  (
    {
      control,
      name,
      placeholder,
      disabled = false,
      required = false,
      autoFocus = false,
      onBlur,
      hideLabel = false,
      sensitiveLabel,
    },
    ref
  ) => {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <ConfidentialInput
            {...field}
            ref={ref}
            name={name}
            placeholder={placeholder}
            errorInfo={error?.message}
            autoFocus={autoFocus}
            error={!!error}
            disabled={disabled}
            required={required}
            onBlur={onBlur}
            hideLabel={hideLabel}
            sensitiveLabel={sensitiveLabel}
          />
        )}
      />
    );
  }
);

export default FormConfidentialInput;
